import { Route, Routes } from "react-router-dom";
import CustomerUserCreateScreen from "screens/App/CRM/CanUsers/CustomerUser/CustomerUserCreateScreen";
import CustomerUserDetailScreen from "screens/App/CRM/CanUsers/CustomerUser/CustomerUserDetailScreen";
import CustomerUserEditScreen from "screens/App/CRM/CanUsers/CustomerUser/CustomerUserEditScreen";
import CustomerUserListScreen from "screens/App/CRM/CanUsers/CustomerUser/CustomerUserListScreen";

const CustomerUserRouter = () => {
    return(
        <Routes>
            <Route path='create' element={<CustomerUserCreateScreen/>} />
            <Route path='list' element={<CustomerUserListScreen />} />
            <Route path=":id/detail" element={<CustomerUserDetailScreen />} />
            <Route path=":id/edit" element={<CustomerUserEditScreen />} />
        </Routes>
    )
}

export default CustomerUserRouter;